(function () {
  'use strict';

  angular
    .module('compartilhamentos')
    .factory('Entidades', EntidadesService);

  function EntidadesService(Restangular) {
    var service = Restangular.service('entidades');

    service.getEntidades = function (enumTipo, uoId) {
      return Restangular.all('auth/entidades/' + enumTipo + '/dona/' + uoId).getList();
    };

    return service;
  }
}());
